import { render, staticRenderFns } from "./DealServiceRequest.vue?vue&type=template&id=6d688308&scoped=true"
import script from "./DealServiceRequest.vue?vue&type=script&lang=js"
export * from "./DealServiceRequest.vue?vue&type=script&lang=js"
import "./DealServiceRequest.vue?vue&type=style&index=0&id=6d688308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d688308",
  null
  
)

export default component.exports